import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "flowName" }, "Name", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Add flow",
    onConfirm: _ctx.onConfirm,
    onCancel: _ctx.onClose,
    "show-footer": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "flowName",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.name]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onConfirm", "onCancel"]))
}